"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportLink = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const StyledLink = (0, styled_components_1.default)(base_react_components_1.Link).withConfig({ displayName: "reports-StyledLink", componentId: "reports-1xvlxoh" }) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 50%;
  border-width: 0;
  & > ${base_react_components_1.Icon} {
    margin-right: 8px;
  }
`;
const getButtonDetails = ({ type }) => {
    switch (type) {
        case 'download':
            return { iconName: 'actions/cloud-download', text: 'Download full report' };
        case 'detail':
            return { iconName: 'data/report', text: 'View full report' };
        case 'analyze':
            return { iconName: 'data/reports-multiple', text: 'Analyze report' };
        default:
            return { iconName: 'data/report', text: 'View full report' };
    }
};
const ReportLink = ({ to, reportType, iconName, text, target, }) => {
    const buttonDetails = reportType ? getButtonDetails({ type: reportType }) : { iconName, text };
    const resolvedIconName = (iconName !== null && iconName !== void 0 ? iconName : buttonDetails.iconName);
    return (react_1.default.createElement(StyledLink, { "data-testid": `global:${reportType}:${reportType}-button`, href: to, target: target },
        !!resolvedIconName && react_1.default.createElement(base_react_components_1.Icon, { name: resolvedIconName }),
        react_1.default.createElement(base_react_components_1.Text, null, text !== null && text !== void 0 ? text : buttonDetails.text)));
};
exports.ReportLink = ReportLink;
exports.default = exports.ReportLink;
//# sourceMappingURL=index.js.map